export default "__VITE_ASSET__8e776f83__"